import React from "react";
import Banner from "./Banner";
import Services from "./Services";
import Technology from "./Technology";
import HowWeHelpYou from "./HowWeHelpYou";
import HowWeDoIt from "./HowWeDoIt";
import Contact from "./Contact";

const Home = () => {
    return (
        <div>
            <Banner/>
            <Services/>
            <Technology/>
            <HowWeHelpYou/>
            <Contact/>
            <HowWeDoIt/>
        </div>
    );
};
export default Home;
